import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getWeek/index.js';

var require$$23 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$23 as default };
